<template>
  <nav>
    <v-list :style="`background-color:` + question.bg_color" :class="role == 'booster' ? 'disable-events' : ''">
      <v-row>
        <v-col cols="12" sm="6" lg="4" v-for="answer in question.options" :key="answer.aid">
          <v-card v-if="role == 'booster'" class="pa-3 fill-height survey-answer-card">
            <div class="survey-answer-image-editor">
              <img v-if="answer.imageDisplay != null" :src="answer.imageDisplay" :path="answer.image"
                class="custom-image large">
              <img v-else src="/assets/editor_images/surveyimageanswer.jpg" class="custom-image large">
            </div>
            <v-list-item class="pa-0">
              <v-textarea readonly disabled auto-grow dense outlined rows="1" v-model="answer.option"
                class="survey-answer survey-answer-image rounded-lg pa-0 ma-0 mt-3 text-body-2" :hide-details="false">
                <template v-slot:prepend-inner>
                  <v-icon class="icon-des mt-n1" color="greytext">mdi-checkbox-blank-outline</v-icon>
                </template>
              </v-textarea>
            </v-list-item>
          </v-card>
          <v-card v-else class="pa-3 fill-height survey-answer-card row-pointer" @click="answerQuestion(answer)"
            :ripple="false" :class="answer.answer ? 'selected' : 'not-selected'" :key="updateComponent">
            <div class="survey-answer-image-editor">
              <img v-if="answer.imageDisplay != null" :src="answer.imageDisplay" :path="answer.image"
                class="custom-image large">
              <img v-else src="/assets/editor_images/surveyimageanswer.jpg" class="custom-image large">
            </div>
            <v-list-item class="pa-0">
              <v-textarea readonly disabled dense outlined no-resize v-model="answer.option"
                class="survey-answer survey-answer-image rounded-lg pa-0 ma-0 mt-3 text-body-2 row-pointer"
                :hide-details="false">
                <template v-slot:prepend-inner>
                  <v-icon v-if="answer.answer" class="icon-des mt-n1 row-pointer"
                    color="greytext">mdi-checkbox-outline</v-icon>
                  <v-icon v-else class="icon-des mt-n1 row-pointer" color="greytext">mdi-checkbox-blank-outline</v-icon>
                </template>
              </v-textarea>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-list>
    <p v-if="showError" class="error--text font-italic">{{ $t('answerError') }}</p>
  </nav>
</template>

<script>

export default {
  props: {
    question: {
      type: Object,
      default: () => { }
    },
    role: {
      type: String,
      default: 'booster'
    },
    invalidAnswers: {
      type: Array,
      default: () => []
    },
    hasSubmittedSurvey: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      updateComponent: '',
      answerObject: {
        type: this.question.type,
        id: this.question.id,
        selections: []
      },
      showError: false
    }
  },
  created() {
    this.$emit('sendAnswer', this.answerObject)
  },
  watch: {
    invalidAnswers() {
      this.showError = false
      if (this.hasSubmittedSurvey && this.invalidAnswers.includes(this.question.id)) {
        this.showError = true
      }
    },
  },
  methods: {
    answerQuestion(answer) {
      answer.answer = !answer.answer
      this.updateComponent = Date.now()
      if (answer.answer) {
        this.answerObject.selections.push(answer.aid)
      } else {
        this.answerObject.selections.splice(this.answerObject.selections.indexOf(answer.aid), 1)
      }
      this.$emit('sendAnswer', this.answerObject)
    }
  }
}
</script>